module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Charging_16"],"polygon":[{"$":{"points":"0 6.82 7 7.82 7 3.82 16 9.82 10 8.82 10 12.82 0 6.82","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Charging_16.svg
// module id = /acj
// module chunks = 1